import React, { useMemo } from "react";
import { Loading } from "../../../components/loading";
import { useOrders } from "../../orders/hooks";
import { useVisits } from "../../visits/hooks";
import { formatDisplayDate } from "../../../helpers/date";

interface IProps {
  customerId: number;
}

const StatTile: React.FC<{ label: string; value: string }> = ({
  label,
  value,
}) => (
  <div className="flex-1 min-w-[140px] bg-gray-50 rounded p-3">
    <p className="text-xs text-gray-500">{label}</p>
    <p className="text-xl font-semibold text-gray-900">{value}</p>
  </div>
);

export const CustomerReport: React.FC<IProps> = ({ customerId }) => {
  const { data: ordersData, loading: ordersLoading } = useOrders({
    where: { customerId },
  });
  const { data: visitsData, loading: visitsLoading } = useVisits({
    where: { customerId },
  });

  const orders = ordersData?.orders?.results ?? [];
  const visits = visitsData?.visits?.results ?? [];

  const totalCa = useMemo(
    () => orders.reduce((sum, order) => sum + (order.totalTtcCents ?? 0), 0),
    [orders]
  );

  const lastVisit = useMemo(() => {
    if (!visits.length) return null;
    return [...visits].sort(
      (a, b) => new Date(b.visitDate).getTime() - new Date(a.visitDate).getTime()
    )[0];
  }, [visits]);

  if (ordersLoading || visitsLoading) return <Loading />;

  return (
    <div className="flex flex-wrap gap-3">
      <StatTile label="Commandes" value={String(orders.length)} />
      <StatTile label="CA total TTC" value={`${(totalCa / 100).toFixed(2)} €`} />
      <StatTile label="Visites" value={String(visits.length)} />
      <StatTile
        label="Dernière visite"
        value={lastVisit ? formatDisplayDate(lastVisit.visitDate) : "-"}
      />
    </div>
  );
};
